import { Sheet, SheetContent } from "@/components/ui/sheet";
import { ViewStipendDetailsSheetContent } from "./ViewStipendDetailsSheetContent";
import { StipendWalletResponse } from "@common/utils/graphql";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  stipend: StipendWalletResponse;
  onSubmitClaim: () => void;
}

export const ViewStipendDetailsSheet = ({
  isOpen,
  stipend,
  onSubmitClaim,
  onClose,
}: Props) => {
  return (
    <Sheet open={isOpen}>
      <SheetContent onClose={onClose} className="overflow-auto scrollbar-thin">
        <ViewStipendDetailsSheetContent
          stipend={stipend}
          onSubmitClaim={onSubmitClaim}
        />
      </SheetContent>
    </Sheet>
  );
};
